import orderBy from 'lodash.orderby';

import {
  currencyInput,
  NativeBooleanEnum,
  nullableStringToNullableFloatConverter,
  numericBooleanFormToUpdateConverter,
  numericBooleanQueryToFormConverter,
} from '@/_schemas/generic';
import { defaultNumericIdOption } from '@/_shared';

import {
  clientOptInToStr,
  type DeliverablesFormSchema,
  type DeliverablesQuerySchema,
  type DeliverablesUpdateSchema,
  strToClientOptIn,
} from './schemas';
import { wholesalePriceQueryToForm } from './wholesale-prices';

export function deliverableQueryToForm(_deliverable: DeliverablesQuerySchema[]): DeliverablesFormSchema[] {
  const deliverable = _deliverable ?? [];
  let inc = deliverable.length > 0 ? orderBy(deliverable, ['sort_order'], ['desc'])[0].sort_order : 1000;
  if (inc === -1) {
    inc = 0;
  }

  const unsorted = deliverable.map((d) => {
    const nSortOrder = !d.sort_order || d.sort_order === -1 ? ++inc : d.sort_order;
    return {
      ...d,
      quantity: currencyInput.queryToFormConverter(d.quantity),
      price: currencyInput.queryToFormConverter(d.price),
      sort_order: nSortOrder,
      client_opt: strToClientOptIn(d.client_opt),
      opted_in: numericBooleanQueryToFormConverter(d.opted_in),
      opted_out: numericBooleanQueryToFormConverter(d.opted_out),
      product: productAndServicesQueryLinkerEnhancer(d.product),
      deliverable_wholesale_price: wholesalePriceQueryToForm(d.deliverable_wholesale_price ?? []),
      description: d.description ?? '',
    };
  });

  return orderBy(unsorted, ['sort_order']);
}

export function deliverableFormToQuery(deliverables: DeliverablesFormSchema[]): DeliverablesUpdateSchema[] {
  return deliverables.map((d) => ({
    ...d,
    quantity: currencyInput.formToUpdateConverter(d.quantity),
    price: currencyInput.formToUpdateConverter(d.price) ?? 0,
    product_id: d.product?.id ?? -1,
    price_frequency_id: d.price_frequency.id,
    sku: d.product?.sku ?? '',
    client_opt: clientOptInToStr(d.client_opt),
    opted_in: numericBooleanFormToUpdateConverter(d.opted_in),
    opted_out: numericBooleanFormToUpdateConverter(d.opted_out),
  }));
}

function productAndServicesQueryLinkerEnhancer(
  data: DeliverablesQuerySchema['product']
): DeliverablesQuerySchema['product'] {
  return {
    ...data,
    sku: data?.sku ?? '',
    list_price: currencyInput.formToUpdateConverter(`${data?.list_price ?? 0}`),
    client_opt: data?.client_opt ? NativeBooleanEnum.True : NativeBooleanEnum.False,
    price_frequency: data?.price_frequency ?? defaultNumericIdOption(),
    wholesale_price: currencyInput.formToUpdateConverter(`${data?.wholesale_price ?? 0}`),
  };
}

export function validatePriceQty(price: string | null, qty: number, _: boolean) {
  const parsedPrice = nullableStringToNullableFloatConverter(price) ?? 0;

  if (parsedPrice < 0 && qty < 0) {
    return { msg: "Price and Qty can't be lesser than 0 at a time", path: 'price' };
  }

  if (qty === 0) {
    return { msg: "Qty can't be 0", path: 'quantity' };
  }
  return null;
}
